import { useEffect, useRef, useState } from 'react';
import { fetchPaymentsV2Query } from '../models/paymentsV2Model';
import { createCommandKeyStore } from '../utilities/idempotency';
import { capability } from '../utilities/paymentPresentation';
export function useQuoteRevision(queryPk, enabled) {
  const [projection, setProjection] = useState(null); const [error, setError] = useState(null);
  const [reason, setReason] = useState(null); const [note, setNote] = useState('');
  const key = useRef(createCommandKeyStore('revision'));
  useEffect(() => {
    let active = true; setProjection(null); setError(null); setReason(null); setNote(''); key.current = createCommandKeyStore('revision');
    if (enabled && queryPk) Promise.resolve(fetchPaymentsV2Query(queryPk)).then(result => { if (active) setProjection(result); }).catch(next => { if (active) setError(next); });
    return () => { active = false; };
  }, [queryPk, enabled]);
  const locked = projection?.invoice_lock_state === 'locked';
  return { locked, error, reason, setReason, note, setNote,
    allowed: !!projection && (!locked || capability(projection, 'can_revise_price').allowed),
    attach: payload => locked ? { ...payload, revision: { reason_code: reason, note: note.trim(), idempotency_key: key.current.get() } } : payload };
}
